/* eslint-disable @typescript-eslint/no-explicit-any */
// Hook odpowiedzialny za edycję odbiorcy

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError, ICommandResponseSuccess } from 'api/types';

const requestKeys = [
  'name',
  'firstName',
  'lastName',
  'email',
  'phone',
  'address.street',
  'address.postalCode',
  'address.city',
  'address.building',
  'address.apartment',
  'address.countryCode'
];

// parametry requestu do api (camelCase, zgodnie z PutReceiversRequestDto)
export interface IRequest {
  name: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  address: {
    street: string;
    postalCode: string;
    city: string;
    building: string;
    apartment: string;
    countryCode: string;
  };
}

type IResponse = ICommandResponseSuccess & {
  data: {
    id: number;
  };
};

const putReceiver = (receiverId: number, data: IRequest): Promise<IResponse> =>
  axios.put(`/receivers/${receiverId}`, data, {
    env: { FormData: { requestKeys: requestKeys } as any }
  });

export const usePutReceiver = (
  receiverId: number,
  options?: UseMutationOptions<IResponse, IError, IRequest>
) => useMutation((data: IRequest) => putReceiver(receiverId, data), options);
